﻿import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'zip'
})
export class ZipPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (value == null || value.length == 0)
            return "";

        let newZip = '';
        switch (value.length) {
            case 9:
                newZip = value.slice(0, 5) + '-' + value.slice(5);
                break;
            case 5:
                newZip = value;
                break;
            default:
                newZip = value;
                break;

        }
        return newZip;
    }

}